'use client'

import { Collapse, CollapseProps, Flex } from 'antd'
import { useGetFAQQuery } from 'shared/common/FAQ/model/api'
import { FAQCategory } from 'shared/common/FAQ/model/types'
import { FAQItem } from 'shared/common/FAQ/ui/FAQItem/Desktop'

import { ReactNode, useState } from 'react'

import styles from './FAQ.module.scss'

interface FAQProps {
  category: FAQCategory
  actionSlot?: ReactNode
}

export function FAQ({ category, actionSlot }: FAQProps) {
  const { data } = useGetFAQQuery({ category })
  const [activeKeys, setActiveKeys] = useState<string[]>([])

  const faqItems = data?.results

  const handleChange = (keys: string | string[]) => {
    setActiveKeys(Array.isArray(keys) ? keys : [keys])
  }

  const items: CollapseProps['items'] = faqItems?.map(
    ({ answer, question }) => ({
      question,
      label: (
        <FAQItem title={question} isActive={activeKeys.includes(question)} />
      ),
      children: <p className={styles.faqText}>{answer}</p>,
    }),
  )

  if (!faqItems?.length) return null

  return (
    <Flex vertical>
      {actionSlot && actionSlot}
      <div className={styles.wrapper}>
        <Collapse
          className={styles.accordion}
          items={items}
          activeKey={activeKeys}
          onChange={handleChange}
          expandIcon={() => null}
        />
      </div>
    </Flex>
  )
}
